
































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AsuhanKebidananGadarStore from "@/store/modules/AsuhanKebidananGadarStore";
import AsuhanKebidananGawatDarurat from "@/services/AsuhanKebidananGawatDarurat";
import AsuhanKeperawatanGadarStore from "@/store/modules/AsuhanKeperawatanGadarStore";
import AsuhanKeperawatanGawatDarurat from "@/services/AsuhanKeperawatanGawatDarurat";
import AsesmenAwalGadar from "@/services/AsesmenAwalGadar/AsesmenAwalGadar";
import AsesmenAwalGadarStore from "@/store/modules/AsesmenAwalGadar";
import storeBilling from "@/store/modules/Billing";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenAwalRanapMedis from "@/services/AsesmenAwalRanapMedis";
import storeAsesmenKemoterapi from "@/store/modules/AsesmenKemoterapi";
import SvcAsesmenKemoterapi from "@/services/AsesmenKemoterapi";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import SvcAsesmenRalan from "@/apiInterface/InterfaceAsesmenRalan";
import TandaVitalTable from "@/components/TandaVitalTable.vue";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import LaporanOperasi from "@/store/modules/LaporanOperasi";
import SvcLaporanOperasi from "@/services/LaporanOperasi";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import CpoRiwayatModal from "@/components/modal/CpoRiwayatModal.vue";
import RencanaAskep from "@/services/RencanaAskep";
import { bandingRencana } from "@/utils/askepRencana";
import ImplementasiAskep from "@/services/ImplementasiAskep";
import PerencanaanModal from "@/components/pemeriksaan/PerencanaanModal.vue";
import ImplementasiModal from "@/components/pemeriksaan/ImplementasiModal.vue";
import RiwayatTransfer from "@/components/pti/RiwayatTransfer.vue";
import PengirimanTransferInternal from "@/components/pti/PengirimanTransferInternal.vue";
import PenerimaanTransferInternal from "@/components/pti/PenerimaanTransferInternal.vue";
import SkriningMpp from "@/components/mpp/SkriningMppModal.vue";
import PerencanaanMpp from "@/components/mpp/PerencanaanMppModal.vue";
import ImplementasiMpp from "@/components/mpp/ImplementasiMppModal.vue";
import mppModule from "@/store/modules/MppStore";
import RujukanEdukasiRiwayat from "@/components/modal/RujukanEdukasiRiwayatModal.vue";
import SuratRujukanEdukasiSvc from "@/services/SuratRujukanEdukasi";
import { Route } from "vue-router";

@Component({
  components: {
    TandaVitalTable,
    CpoRiwayatModal,
    PerencanaanModal,
    ImplementasiModal,
    RiwayatTransfer,
    PenerimaanTransferInternal,
    PengirimanTransferInternal,
    SkriningMpp,
    PerencanaanMpp,
    ImplementasiMpp,
    RujukanEdukasiRiwayat
  }
})
export default class CardListRekamMedis extends Vue {
  @Prop() register: number;
  modalRiwayat = false;

  modalCPO() {
    this.modalRiwayat = true;
  }
  @Prop() pasien_rm: number;

  //transfer internal
  dialogDetailTransfer = false;
  dialogDetailPti = false;
  selectedPtiData: any = null;
  selectedPtiId: number | null = null;
  countTransfer = 0;
  sudahLoadTransfer = false;

  mounted() {
    this.resetTransferState();
  }

  listRencanaAskep = [];
  listImplementasiAskep = [];
  showRencanaAskep = false;
  showImplementasiAskep = false;

  //mpp
  listSkriningMpp = [];
  listRencanaMpp = [];
  listImplementasiMpp = [];
  showSkriningMpp = false;
  showRencanaMpp = false;
  showImplementasiMpp = false;

  suratRujukanEdukasi: any = null;
  showRujukanEdukasi = false;

  get hasilProcedure() {
    return storeBilling.procedure;
  }

  get hasilDiagnosis() {
    return storeBilling.diagnosis;
  }
  get headDiag() {
    const head = [
      {
        text: "Kode",
        value: "kode",
        width: "10vh",
        align: "center"
      },
      {
        text: "Deskripsi Diagnosa",
        value: "nama",
        align: "left"
      },
      {
        text: "Kasus",
        value: "kasus",
        align: "center",
        width: "15vh"
      },
      {
        text: "Level",
        value: "level",
        align: "center",
        width: "20vh"
      }
    ];
    return head;
  }
  get headProc() {
    const head = [
      {
        text: "Kode",
        value: "kode",
        width: "10vh",
        align: "center"
      },
      {
        text: "Deskripsi Prosedur / Tindakan",
        value: "nama",
        align: "left"
      }
    ];
    return head;
  }

  get listAskeb() {
    return AsuhanKebidananGadarStore.listAsKeb;
  }
  get listAskep() {
    return AsuhanKeperawatanGadarStore.listAsKep;
  }
  get asesmenGadar() {
    return AsesmenAwalGadarStore.asesmen;
  }
  get asesmenRanapMedis() {
    return AsesmenAwalRanapMedisStore.asesmen;
  }
  get asesmenKemoterapi() {
    return storeAsesmenKemoterapi.dataAsesmenKemoterapi;
  }
  get asesmenAwalRalan() {
    return storeAssesmenRalan.asesmenAwal;
  }

  get listTtv() {
    return TandaVitalStore.list;
  }

  get lapOp() {
    return LaporanOperasi.dataList;
  }

  get cpoList() {
    if (
      !this.register ||
      CatatanPemberianObatStore.registerId !== String(this.register)
    ) {
      return [];
    }

    return this.mapData(CatatanPemberianObatStore.dataList);
  }

  mapData(rawData) {
    return rawData.map(item => {
      const mapTanggal = {};

      item.pemberian.forEach(p => {
        if (!mapTanggal[p.date]) {
          mapTanggal[p.date] = [];
        }
        mapTanggal[p.date].push(p);
      });

      return {
        ...item,
        pemberianMap: mapTanggal
      };
    });
  }

  @Watch("register", { immediate: true })
  onRegisterChange(newVal: number, oldVal: number) {
    if (newVal !== oldVal) {
      this.resetDataRegister();
    }

    if (newVal) {
      this.getDataAskepRanap();
      this.getDataMpp();
      this.getDataRujukanEdukasi();
    }

    if (newVal !== oldVal) {
      this.resetTransferState();
    }
  }

  cetakAskeb(reg) {
    AsuhanKebidananGawatDarurat.print(reg);
  }
  cetakAskep(reg) {
    AsuhanKeperawatanGawatDarurat.print(reg);
  }
  cetakAsesIgd(reg) {
    console.log("cetak ases gadar", reg);
    AsesmenAwalGadar.printByRegister(reg);
  }
  cetakAsesRanapMedis(id) {
    AsesmenAwalRanapMedis.print(id);
  }
  cetakAsesmenKemo(id) {
    SvcAsesmenKemoterapi.print(id);
  }
  cetakAsesmenRalan(id) {
    SvcAsesmenRalan.print(id);
  }
  cetakLaporanOperasi(id) {
    SvcLaporanOperasi.print(id);
  }

  async getDataAskepRanap() {
    await RencanaAskep.getByRegister(this.register).then(res => {
      this.listRencanaAskep = (res.data || []).slice().sort(bandingRencana);
    });

    await ImplementasiAskep.getByRegister(this.register).then(res => {
      this.listImplementasiAskep = res.data.sort(
        (a, b) =>
          new Date(b.authored_at).getTime() - new Date(a.authored_at).getTime()
      );
    });
  }

  async getDataMpp() {
    await mppModule.fetchAllMpp(this.register);

    console.log("Skrining dari Store:", mppModule.getSkrining);
    console.log("Implementasi dari Store:", mppModule.getImplementasi);

    this.listSkriningMpp = mppModule.getSkrining;
    this.listRencanaMpp = mppModule.getPerencanaan;
    this.listImplementasiMpp = mppModule.getImplementasi;
  }

  resetDataRegister() {
    this.listRencanaAskep = [];
    this.listImplementasiAskep = [];
    this.listSkriningMpp = [];
    this.listRencanaMpp = [];
    this.listImplementasiMpp = [];
    this.suratRujukanEdukasi = null;
    this.showRencanaAskep = false;
    this.showImplementasiAskep = false;
    this.showSkriningMpp = false;
    this.showRencanaMpp = false;
    this.showImplementasiMpp = false;
    this.showRujukanEdukasi = false;
  }

  async getDataRujukanEdukasi() {
    const reg = this.register;

    try {
      const resp = await SuratRujukanEdukasiSvc.getByRegister(reg);
      if (reg !== this.register) return;
      this.suratRujukanEdukasi = resp?.data?.data ?? null;
    } catch {
      if (reg !== this.register) return;
      this.suratRujukanEdukasi = null;
    }
  }

  showDetailTransfer() {
    this.dialogDetailTransfer = true;
  }
  closeDialog() {
    this.dialogDetailTransfer = false;
  }

  //transfer internal
  openFullFormDetail(rawData: any, id: number) {
    this.selectedPtiData = rawData;
    this.selectedPtiId = id;
    this.dialogDetailPti = true;

    // this.dialogDetailTransfer = false;
  }

  closePtiDialog() {
    this.dialogDetailPti = false;
    this.selectedPtiData = null;
    this.selectedPtiId = null;
  }

  @Watch("$route", { deep: true })
  onRouteChange(to: Route, from: Route) {
    if (to.path !== from.path || to.params.register !== from.params.register) {
      this.resetTransferState();
    }
  }

  resetTransferState() {
    console.log("Resetting Transfer State...");
    this.countTransfer = 0;
    this.sudahLoadTransfer = false;
    this.selectedPtiData = null;
    this.selectedPtiId = null;

    if (this.dialogDetailTransfer) this.dialogDetailTransfer = false;
    if (this.dialogDetailPti) this.dialogDetailPti = false;
  }

  handleUpdateCount(count: number) {
    this.countTransfer = count;
    this.sudahLoadTransfer = true;
  }
}
